// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Zones_tableWrapper__KJ86-"};